import { size } from '../theme';

const DIMENSION_IMG_REGEX = /\d+x\d+/;

export const BASE_IMAGE_CDN_URL = 'https://img2.storyblok.com/';

export const hasDimensions = src => DIMENSION_IMG_REGEX.test(src);

export const getDimensions = src => {
  const [width, height] = src.match(DIMENSION_IMG_REGEX)[0].match(/\d+/g);
  return { width: Number(width), height: Number(height) };
};

export const getMediaQuery = breakpoint => {
  switch (breakpoint) {
    case 'desktop':
      return null;
    case 'tablet':
      return `(max-width: 1023px)`;
    default:
      return `(max-width: ${size.tabletS})`;
  }
};

// `src` is expected to be a full-sized image at 3x image scale
// This generates the @2x and base image scales
export const getSrcSets = (src, pixelDensities = [1 / 3, 2 / 3]) => {
  const baseUrl = BASE_IMAGE_CDN_URL;
  const endUrl = src.match(/\/f\/.+\.(?:jpg|png)$/);
  const { width } = getDimensions(src);
  const images = [{ pixelDensity: 3, src, width: Number(width) }];
  pixelDensities.forEach(scale => {
    const imageWidth = Math.round(width * scale);
    images.push({
      pixelDensity: 3 * scale,
      src: `${baseUrl}${imageWidth}x0${endUrl}`,
      width: imageWidth,
    });
  });

  return images.sort((a, b) => a.pixelDensity - b.pixelDensity);
};

export const getSrcSetString = src => {
  const srcSets = getSrcSets(src);
  return srcSets.reduce((acc, { width, src }) => {
    return acc + `${src} ${width}w, `;
  }, '');
};

export const storyblokAspectRatio = src => {
  const { width, height } = getDimensions(src);

  return `${(height / width) * 100}%`;
};
